import { Home, Refresh } from '@mui/icons-material';
import { Box, Button, Card, Container, Grid, Icon, IconButton, Stack, Switch, Typography, styled, useTheme } from '@mui/material'
import React, { useState } from 'react'
import Loading from '../../../../../../components/loading/Loading';
import DataNotFound from '../../../../../../components/error/DataNotFound';

function ControlTabContent({ data, onRefreshClick }) {
    const { spacing, palette } = useTheme()

    const [FORCE_DG, setFORCE_DG] = useState(data?.FORCE_DG == "START" && true || data?.FORCE_DG == "STOP" && false);
    const [DG_START, setDG_START] = useState(data?.DG_START == "Auto" && true || data?.DG_START == "Manual" && false)
    const [INVERTER_RESET_BUZZ_OFF, setINVERTER_RESET_BUZZ_OFF] = useState(data?.INVERTER_RESET_BUZZ_OFF == "No Action" && true || data?.INVERTER_RESET_BUZZ_OFF == "Reset" && false)
    const [INVERTER, setINVERTER] = useState(data?.INVERTER == "START" && true || data?.INVERTER == "STOP" && false)
    const [BUZZER, setBUZZER] = useState(data?.BUZZER == "Active" && true || data?.BUZZER == "Disable" && false)
    const [EMERGENCY_OFF, setEMERGENCY_OFF] = useState(data?.EMERGENCY_OFF == "Active" && true || data?.EMERGENCY_OFF == "Disable" && false)
    const [MPPT1, setMPPT1] = useState(data?.MPPT1 == "Active" && true || data?.MPPT1 == "Disable" && false)
    const [MPPT2, setMPPT2] = useState(data?.MPPT2 == "Active" && true || data?.MPPT2 == "Disable" && false)
    const [MPPT3, setMPPT3] = useState(data?.MPPT3 == "Active" && true || data?.MPPT3 == "Disable" && false)
    const [GRID_CHARGING, setGRID_CHARGING] = useState(data?.GRID_CHARGING == "Active" && true || data?.GRID_CHARGING == "Disable" && false)
    const [EXPORT, setEXPORT] = useState(data?.EXPORT == "Active" && true || data?.EXPORT == "Disable" && false)
    const [BATTERY_TEST, setBATTERY_TEST] = useState(data?.BATTERY_TEST == "START" && true || data?.BATTERY_TEST == "STOP" && false)
    const [MANUAL_EQUILIZE, setMANUAL_EQUILIZE] = useState(data?.MANUAL_EQUILIZE == "START" && true || data?.MANUAL_EQUILIZE == "STOP" && false)
    const [FORCE_BYPASS, setFORCE_BYPASS] = useState(data?.FORCE_BYPASS == "No Action" && true || data?.FORCE_BYPASS == "Transfer" && false)
    const [AUTO_RESTART, setAUTO_RESTART] = useState(data?.AUTO_RESTART == "Enable" && true || data?.AUTO_RESTART == "Disable" && false)

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: palette.error.main,
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    return (
        <Box>
            <Stack direction={'row'} py={spacing(1)} justifyContent={'end'}>
                <Button type='submit' onClick={onRefreshClick} startIcon={<Refresh />} variant='contained'>Refresh</Button>
            </Stack>


            <Grid spacing={spacing(1)} container>
                <Grid item xs={12} sm={4}>
                    <Stack rowGap={spacing(1)}>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Force DG Start/Stop</Typography>
                            <IOSSwitch
                                checked={FORCE_DG}
                                onChange={(event) => setFORCE_DG(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Inverter Start/Stop</Typography>
                            <IOSSwitch
                                checked={INVERTER}
                                onChange={(event) => setINVERTER(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>MPPT 1 On/Off</Typography>
                            <IOSSwitch
                                checked={MPPT1}
                                onChange={(event) => setMPPT1(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Grid Charging On/Off</Typography>
                            <IOSSwitch
                                checked={GRID_CHARGING}
                                onChange={(event) => setGRID_CHARGING(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Manual Equilize</Typography>
                            <IOSSwitch
                                checked={MANUAL_EQUILIZE}
                                onChange={(event) => setMANUAL_EQUILIZE(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>

                    </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Stack rowGap={spacing(1)}>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>DG Start Auto/Manual</Typography>
                            <IOSSwitch
                                checked={DG_START}
                                onChange={(event) => setDG_START(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Buzzer Disable</Typography>
                            <IOSSwitch
                                checked={BUZZER}
                                onChange={(event) => setBUZZER(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>MPPT 2 On/Off</Typography>
                            <IOSSwitch
                                checked={MPPT2}
                                onChange={(event) => setMPPT2(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Export On/Off</Typography>
                            <IOSSwitch
                                checked={EXPORT}
                                onChange={(event) => setEXPORT(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Force bypass transfer</Typography>
                            <IOSSwitch
                                checked={FORCE_BYPASS}
                                onChange={(event) => setFORCE_BYPASS(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                    </Stack>

                </Grid>
                <Grid item xs={12} sm={4}>
                    <Stack rowGap={spacing(1)}>

                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Inverter Reset/Buzz Off</Typography>
                            <IOSSwitch
                                checked={INVERTER_RESET_BUZZ_OFF}
                                onChange={(event) => setINVERTER_RESET_BUZZ_OFF(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Emergency Off</Typography>
                            <IOSSwitch
                                checked={EMERGENCY_OFF}
                                onChange={(event) => setEMERGENCY_OFF(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>MPPT 3 On/Off</Typography>
                            <IOSSwitch
                                checked={MPPT3}
                                onChange={(event) => setMPPT3(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Battery Test</Typography>
                            <IOSSwitch
                                checked={BATTERY_TEST}
                                onChange={(event) => setBATTERY_TEST(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                        <Stack component={Card} p={spacing(1)} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
                            <Typography variant='body2'>Auto Restart Enable/Disable</Typography>
                            <IOSSwitch
                                checked={AUTO_RESTART}
                                onChange={(event) => setAUTO_RESTART(event.target.checked)}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>




        </Box >
    )
}

export default ControlTabContent
